export default __webpack_public_path__ + "static/media/fondGris.653a8de0.png";